import { useHistory } from 'react-router-dom';

function useSearchParam(name: string, opts?: { int: false }): string | null;
function useSearchParam(
  name: string,
  opts?: { int: true; onParseError?: () => void }
): number | null;
function useSearchParam<const T extends string>(
  name: T,
  opts?: { int: boolean; onParseError?: () => void }
): string | number | null {
  const int = opts?.int ?? false;
  const history = useHistory();
  const searchParams = new URLSearchParams(history.location.search);
  const value_ = searchParams.get(name);
  if (!value_) return null;
  if (int) {
    const parsed = Number.parseInt(value_);
    if (isNaN(parsed)) {
      opts?.onParseError?.();
    }
    return parsed;
  }
  return value_;
}

export default useSearchParam;
